import React, { useState } from 'react';
import { Button, Dialog } from '@mui/material';
import { entityNameMinimumLength, validateEntityName } from 'const/regex';
import { CreateTenantInterface, useTenantsContext } from './tenants.context';
import { FormFieldInterface } from 'components/Form/Form.types';
import Form from 'components/Form/Form';

const defaultTenant: CreateTenantInterface = {
  name: '',
};

const CreateTenant = (): JSX.Element => {
  const [show, setShow] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { addTenant } = useTenantsContext();
  const [newTenant, setNewTenant] = useState<CreateTenantInterface>(defaultTenant);

  const handleAddTenant = async () => {
    setLoading(true);
    await addTenant(newTenant);
    setNewTenant(defaultTenant);
    setShow(false);
    setLoading(false);
  };

  const fields: FormFieldInterface[] = [
    {
      label: 'Tenant Name',
      value: newTenant.name,
      onChange: (name) => setNewTenant({ ...newTenant, name }),
      fullWidth: true,
      validator: validateEntityName,
      requiredMinimumLength: entityNameMinimumLength,
    },
  ];

  return (
    <>
      <Button variant='contained' color='secondary' onClick={() => setShow(true)}>
        Create New Tenant
      </Button>
      <Dialog open={show} onClose={() => setShow(false)}>
        <Form
          fields={fields}
          title='Create New Tenant'
          onSubmit={handleAddTenant}
          submitting={loading}
          buttonText='Create Tenant'
        />
      </Dialog>
    </>
  );
};

export default CreateTenant;
